import a from "./index60.js";
function R(i, f, t) {
  const u = t.config.validateStatus;
  !t.status || !u || u(t.status) ? i(t) : f(new a(
    "Request failed with status code " + t.status,
    t.status >= 400 && t.status < 500 ? a.ERR_BAD_REQUEST : a.ERR_BAD_RESPONSE,
    t.config,
    t.request,
    t
  ));
}
export {
  R as default
};
